import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _compact from "lodash/compact";
import "core-js/modules/es6.array.map.js";
import { getName, getId, getProductType } from '@nerdwallet/marketplace/selectors/common';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { getImageData, DEFAULT_DRIVER_GROUP } from '../../utils';
import mapPropsAutoLoans, { DRIVER_GROUPS_AUTO_LOANS } from './auto-loans';
import mapPropsBanking from './banking';
import mapPropsCreditCards, { DRIVER_GROUPS_CREDIT_CARDS } from './credit-cards';
import mapPropsEducationLoans, { DRIVER_GROUPS_EDUCATION_LOANS } from './education-loans';
import mapPropsInvesting, { DRIVER_GROUPS_INVESTING } from './investing';
import mapPropsMortgages from './mortgages';
import mapPropsPersonalLoans, { DRIVER_GROUPS_PERSONAL_LOANS } from './personal-loans';
import mapPropsSmbLoans, { DRIVER_GROUPS_SMB_LOANS } from './small-medium-business-loans';

/**
 * `entity` may be a marketplaceEntity, or it may be an object with
 * `marketplaceEntity` in it
 */
var getMarketplaceEntity = function getMarketplaceEntity(entity) {
  var _entity$marketplaceEn;

  return (_entity$marketplaceEn = entity === null || entity === void 0 ? void 0 : entity.marketplaceEntity) !== null && _entity$marketplaceEn !== void 0 ? _entity$marketplaceEn : entity;
};
/**
 * Extracts `additionalEntityData` if it exists. Defaults to an empty object
 */


var getAdditionalEntityData = function getAdditionalEntityData(entity) {
  var _entity$additionalEnt;

  return (_entity$additionalEnt = entity === null || entity === void 0 ? void 0 : entity.additionalEntityData) !== null && _entity$additionalEnt !== void 0 ? _entity$additionalEnt : {};
};

export default (function (_ref) {
  var currentEntities = _ref.currentEntities,
      driverGroup = _ref.driverGroup;

  var mappedEntities = _compact(currentEntities.map(function (entity) {
    if (!entity) return undefined;
    var marketplaceEntity = getMarketplaceEntity(entity);
    var additionalEntityData = getAdditionalEntityData(entity);
    var mappedProps = {};
    var productType = getProductType(marketplaceEntity);

    switch (productType) {
      case PRODUCT_TYPES.AUTO_LOANS:
        mappedProps = mapPropsAutoLoans({
          driverGroup: driverGroup,
          marketplaceEntity: marketplaceEntity
        });
        break;

      case PRODUCT_TYPES.BANKING:
        mappedProps = mapPropsBanking({
          marketplaceEntity: marketplaceEntity
        });
        break;

      case PRODUCT_TYPES.CREDIT_CARDS:
        mappedProps = mapPropsCreditCards({
          driverGroup: driverGroup,
          marketplaceEntity: marketplaceEntity
        });
        break;

      case PRODUCT_TYPES.EDUCATION_LOANS:
        mappedProps = mapPropsEducationLoans({
          driverGroup: driverGroup,
          marketplaceEntity: marketplaceEntity
        });
        break;

      case PRODUCT_TYPES.INVESTING:
        mappedProps = mapPropsInvesting({
          driverGroup: driverGroup,
          marketplaceEntity: marketplaceEntity
        });
        break;

      case PRODUCT_TYPES.MORTGAGES:
        mappedProps = mapPropsMortgages(marketplaceEntity.mortechData);
        break;

      case PRODUCT_TYPES.PERSONAL_LOANS:
        mappedProps = mapPropsPersonalLoans({
          additionalEntityData: additionalEntityData,
          driverGroup: driverGroup,
          marketplaceEntity: marketplaceEntity
        });
        break;

      case PRODUCT_TYPES.SMB_LOANS:
        mappedProps = mapPropsSmbLoans({
          driverGroup: driverGroup,
          marketplaceEntity: marketplaceEntity
        });
        break;

      default:
        mappedProps = {};
        break;
    }

    return _objectSpread({
      imageInfo: _objectSpread({}, getImageData(marketplaceEntity)),
      id: getId(marketplaceEntity),
      productName: getName(marketplaceEntity),
      marketplaceEntity: marketplaceEntity,
      applyNow: entity.applyNow
    }, mappedProps);
  }));

  return {
    mappedEntities: mappedEntities
  };
});
export var DRIVER_GROUPS = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_defineProperty({}, DEFAULT_DRIVER_GROUP, DEFAULT_DRIVER_GROUP), DRIVER_GROUPS_AUTO_LOANS), DRIVER_GROUPS_CREDIT_CARDS), DRIVER_GROUPS_EDUCATION_LOANS), DRIVER_GROUPS_INVESTING), DRIVER_GROUPS_PERSONAL_LOANS), DRIVER_GROUPS_SMB_LOANS);